import { Navigate, useNavigate, useParams, useRoutes } from "react-router-dom"
import { useCallback } from "react"
import { TaskAssignmentPage } from "./TaskAssignmentPage"
import { TaskListPage } from "./TaskListPage"
import { assertIsDefined } from "@/utils/assetIsDefined"
import { genCleaningReportPagePath } from "@/routes/protected"
import { useCleaningTasks } from "@/hooks/useCleaningTasks"

export const TasksPage = () => {
    const { cleaningId } = useParams<"cleaningId">()

    assertIsDefined(cleaningId)

    const {
        data: tasks,
        requestPutTaskPicture,
        completeTaskPicture
    } = useCleaningTasks(cleaningId)
    const navigate = useNavigate()
    const handleSkipReport = useCallback(
        (taskIndex: number) => {
            navigate(
                genCleaningReportPagePath(cleaningId, `tasks/${taskIndex + 1}`)
            )
        },
        [navigate, cleaningId]
    )

    const gotoNextTask = useCallback(
        (taskIndex: number) => {
            navigate(
                genCleaningReportPagePath(cleaningId, `tasks/${taskIndex + 1}`)
            )
        },
        [navigate, cleaningId]
    )

    const goToAssignmentPage = useCallback(() => {
        navigate(genCleaningReportPagePath(cleaningId, "tasks/0"))
    }, [navigate, cleaningId])

    const routes = [
        {
            path: "list",
            element: tasks ? (
                <TaskListPage
                    tasks={tasks}
                    cleaningId={cleaningId}
                    handleTaskAssignmentPage={goToAssignmentPage}
                />
            ) : null
        },
        {
            path: ":index",
            element: tasks ? (
                <TaskAssignmentPage
                    tasks={tasks}
                    requestPutTaskPicture={requestPutTaskPicture}
                    completeTaskPicture={completeTaskPicture}
                    handleSkip={handleSkipReport}
                    gotoNextTask={gotoNextTask}
                />
            ) : null
        },
        {
            index: true,
            element: (
                <Navigate
                    to={genCleaningReportPagePath(cleaningId, "tasks/0")}
                />
            )
        }
    ]

    const element = useRoutes(routes)

    if (tasks?.length === 0) {
        return (
            <Navigate to={genCleaningReportPagePath(cleaningId, "evidences")} />
        )
    }

    return element
}
